import React, { createContext, useState, ReactNode } from 'react';
import { AppSettings, AppSettingsContextType } from './types';
import { AppSettingsProvider as AppSettingsProviderImpl } from './provider';

export const AppSettingsContext = createContext<AppSettingsContextType | undefined>(undefined);

interface AppSettingsWrapperProps {
  children: ReactNode;
}

export function AppSettingsWrapper({ children }: AppSettingsWrapperProps) {
  const [settings, setSettings] = useState<AppSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  console.log('🎯 [AppSettingsWrapper] Current state:', { loading, hasSettings: !!settings });

  const handleSettingsChange = (newSettings: AppSettings | null) => {
    console.log('📥 [AppSettingsWrapper] Settings changed:', newSettings);
    setSettings(newSettings);
  };

  const handleLoadingChange = (newLoading: boolean) => {
    console.log('🔄 [AppSettingsWrapper] Loading changed:', newLoading);
    setLoading(newLoading);
  };

  const handleSavingChange = (newSaving: boolean) => {
    console.log('💾 [AppSettingsWrapper] Saving changed:', newSaving);
    setSaving(newSaving);
  };

  const saveSettings = async (newSettings: Partial<AppSettings>) => {
    const provider = (window as any).__appSettingsProvider;
    if (provider?.saveSettings) {
      return await provider.saveSettings(newSettings);
    }
    return false;
  };

  const reloadSettings = async () => {
    const provider = (window as any).__appSettingsProvider;
    if (provider?.reloadSettings) {
      await provider.reloadSettings();
    }
  };

  const value: AppSettingsContextType = {
    settings,
    loading,
    saving,
    saveSettings,
    reloadSettings
  };

  return (
    <AppSettingsContext.Provider value={value}>
      <AppSettingsProviderImpl
        onSettingsChange={handleSettingsChange}
        onLoadingChange={handleLoadingChange}
        onSavingChange={handleSavingChange}
      >
        {children}
      </AppSettingsProviderImpl>
    </AppSettingsContext.Provider>
  );
}